import { render, staticRenderFns } from "./policiesOverviewPage.vue?vue&type=template&id=0bb4b19b&"
import script from "./policiesOverviewPage.vue?vue&type=script&lang=js&"
export * from "./policiesOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./policiesOverviewPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports